var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "table",
    {
      staticClass: "admin_contentmodules table default",
    },
    [
      _c("colgroup", [
        _vm.filterCategory === null
          ? _c("col", {
              staticStyle: {
                width: "20px",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("col", {
          staticStyle: {
            width: "20px",
          },
        }),
        _vm._v(" "),
        _c("col"),
        _vm._v(" "),
        _c("col", {
          staticStyle: {
            width: "24px",
          },
        }),
      ]),
      _vm._v(" "),
      _c("thead", [
        _c("tr", [
          _vm.filterCategory === null ? _c("th") : _vm._e(),
          _vm._v(" "),
          _c("th"),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass: "actions",
            },
            [_vm._v(_vm._s(_vm.$gettext("Aktionen")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "draggable",
        {
          attrs: {
            handle: ".dragarea",
            tag: "tbody",
          },
          model: {
            value: _vm.sortedModules,
            callback: function callback($$v) {
              _vm.sortedModules = $$v
            },
            expression: "sortedModules",
          },
        },
        _vm._l(_vm.activeModules, function (module) {
          return _c(
            "tr",
            {
              key: module.id,
              class: _vm.getModuleCSSClasses(module),
            },
            [
              _vm.filterCategory === null
                ? _c("td", [
                    module.active
                      ? _c(
                          "a",
                          {
                            ref: "draghandle-".concat(module.id),
                            refInFor: true,
                            staticClass: "dragarea",
                            attrs: {
                              tabindex: "0",
                              "aria-label": _vm.$gettextInterpolate(
                                _vm.$gettext(
                                  "Sortierelement für Module %{module}. Drücken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben."
                                ),
                                {
                                  module: module.displayname,
                                },
                                true
                              ),
                            },
                            on: {
                              keydown: function keydown($event) {
                                return _vm.keyboardHandler($event, module)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "drag-handle",
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [
                !module.mandatory
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: module.active,
                          expression: "module.active",
                        },
                      ],
                      ref: "checkbox_" + module.id,
                      refInFor: true,
                      attrs: {
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(module.active)
                          ? _vm._i(module.active, null) > -1
                          : module.active,
                      },
                      on: {
                        click: function click($event) {
                          return _vm.toggleModuleActivation(module)
                        },
                        change: function change($event) {
                          var $$a = module.active,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(module, "active", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  module,
                                  "active",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(module, "active", $$c)
                          }
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "upper_part",
                    class: {
                      dragrea: module.active,
                    },
                    attrs: {
                      href: _vm.getDescriptionURL(module),
                      "data-dialog": "",
                    },
                  },
                  [
                    module.icon
                      ? _c("img", {
                          staticClass: "text-bottom",
                          attrs: {
                            src: module.icon,
                            width: "20",
                            height: "20",
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n                    " +
                        _vm._s(module.displayname) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "actions",
                },
                [
                  _vm.showVisibilityToggle(module)
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            role: "checkbox",
                            "aria-checked":
                              module.visibility !== "tutor" ? "true" : "false",
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.toggleModuleVisibility(module)
                            },
                          },
                        },
                        [
                          _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape:
                                module.visibility !== "tutor"
                                  ? "visibility-visible"
                                  : "visibility-invisible",
                              title: _vm.$gettextInterpolate(
                                _vm.$gettext(
                                  "Inhaltsmodul %{ name } für Teilnehmende unsichtbar bzw. sichtbar schalten"
                                ),
                                {
                                  name: module.displayname,
                                },
                                true
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  module.active
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.getRenameURL(module),
                            "data-dialog": "size=auto",
                          },
                        },
                        [
                          _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape: "edit",
                              title: _vm.$gettextInterpolate(
                                _vm.$gettext(
                                  "Umbenennen des Inhaltsmoduls %{ name }"
                                ),
                                {
                                  name: module.displayname,
                                },
                                true
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.inactiveModules, function (module) {
          return _c(
            "tr",
            {
              key: module.id,
              class: _vm.getModuleCSSClasses(module),
            },
            [
              _vm.filterCategory === null ? _c("td") : _vm._e(),
              _vm._v(" "),
              _c("td", [
                !module.mandatory
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: module.active,
                          expression: "module.active",
                        },
                      ],
                      ref: "checkbox_" + module.id,
                      refInFor: true,
                      attrs: {
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(module.active)
                          ? _vm._i(module.active, null) > -1
                          : module.active,
                      },
                      on: {
                        click: function click($event) {
                          return _vm.toggleModuleActivation(module)
                        },
                        change: function change($event) {
                          var $$a = module.active,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(module, "active", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  module,
                                  "active",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(module, "active", $$c)
                          }
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "upper_part",
                    attrs: {
                      href: _vm.getDescriptionURL(module),
                      "data-dialog": "",
                    },
                  },
                  [
                    module.icon
                      ? _c("img", {
                          staticClass: "text-bottom",
                          attrs: {
                            src: module.icon,
                            width: "20",
                            height: "20",
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n                    " +
                        _vm._s(module.displayname) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("td"),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }